import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from 'dompurify';
import validator from 'validator';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getFullImageUrl(imagePath: string): string {
  if (imagePath?.startsWith("http://") || imagePath?.startsWith("https://")) {
    return imagePath;
  }

  const baseUrl = process.env.PAYLOAD_GRAPHQL_ENDPOINT;

  if (imagePath?.startsWith("/")) {
    return `${baseUrl}${imagePath}`;
  }

  return `${baseUrl}/${imagePath}`;
}

export function formatLink(data: any) {
  let url = "#";

  if (
    (data.linkType === false || data.linkType === "internal" || data?.navType === "internal") &&
    data.internalLink?.value?.slug
  ) {
    url = `/${data.internalLink.value.slug}`;
  } else if (data.linkType && data.externalURL) {
    url = data.externalURL;
  }

  return url;
}


export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  // const hours = String(date.getHours()).padStart(2, '0');
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${day}-${month}-${year}`;
};

export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const sanitizeInput = (input: string): string => {
  if (!input) return '';
  
  const cleaned = DOMPurify.sanitize(input, { 
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });
  
  return cleaned.replace(/[<>\"'%;()&+]/g, '');
};

export const sanitizeEmail = (email: string): string => {
  if (!email) return '';
  
  if (!validator.isEmail(email)) {
    throw new Error('Email inválido');
  }
  
  return validator.normalizeEmail(email) || '';
};

export const sanitizePhone = (phone: string): string => {
  if (!phone) return '';
  
  return phone.replace(/[^\d\s+\-()]/g, '');
};
